import { Dropdown, Menu } from 'antd'
import { UserRoleEnum } from 'enums'
import React from 'react'
import { Link } from 'react-router-dom'
import { ArrowIcon } from '../assets/icons'
import logo from '../assets/images/logo.png'
import { history } from '../utils/history'

interface HeaderProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  userName: string
  headerClassName: string
  logoClassName: string
  logoProfile: string
}

export const RWDHeader = (props: HeaderProps) => {
  const { role, userName, headerClassName, logoClassName, logoProfile, ...rest } = props
  const defaultLogo =
    'https://developmentreachwaremvp.blob.core.windows.net/reachware-attachments/cnrVti2Kxr1dbsxsVcoFn.png'

  const logout = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault()
    localStorage.removeItem('token')
    history.push(`/login`)
  }

  const setting = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault()
    if (role === UserRoleEnum.ADMIN) {
      history.push(`/admin/settings`)
    } else if (role === UserRoleEnum.TENANT_USER || UserRoleEnum.TENANT_ADMIN) {
      history.push(`/tenant/settings`)
    }
  }

  const menu = (
    <Menu
      items={[
        {
          key: '1',
          label: <span onClick={logout}>Log out</span>,
        },
        {
          key: '2',
          label: <span onClick={setting}>Setting</span>,
        },
      ]}
    />
  )
  return (
    <div {...rest} className={headerClassName}>
      <Link className=' w-[250px] px-[39px] py-[16px] h-full flex items-center' to={'/'}>
        <img src={logo} className={logoClassName} alt='Reachware Logo' />
      </Link>
      <div className='flex  justify-between  items-center px-[30px] cursor-pointer hover:text-left '>
        <h4 className=' text-center text-base m-0 pr-5 '>Hi, {userName}</h4>
        <Dropdown overlay={menu} placement='bottomRight'>
          <ArrowIcon className='fill-black w-8 h-9 rotate-90 ' />
        </Dropdown>
        <span className='pl-3'>
          <img
            alt='logo'
            src={logoProfile == 'null' || logoProfile == '' || logoProfile == null ? defaultLogo : logoProfile}
            width={40}
            height={40}
            className='img-fluid'
          ></img>
        </span>
      </div>
    </div>
  )
}
